/**
 * @author Ariel
 * @description 消息通知记录页面配置
 * @Date 2021-06-24
 */
import React from "react";
import {component_tool,framework_tool} from '../../../tool';
import { WizTableForm } from '@/containers/common'

const {WizRow,WizCol,WizSelect,WizTooltip} = component_tool
let componentName = 'messageNoticeRecord'
let Option = WizSelect.Option

const columns = (e) => {
  let {self} = e
  let {sceneByTypeList,entityType} = self.state
  let flag = true
  if (entityType >= 0) {
    flag = false
  }
  return [
    {
      name: 'id',
      formItem: { type: 'hidden' }
    },
    {
      title: '业务类型',
      name: 'entityType',
      searchItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form;
          return (
            <WizRow>
              <WizCol>
                {
                  getFieldDecorator('entityType',{
                    initialValue: entityType
                  })(
                    <WizSelect
                      placeholder="请选择业务类型"
                      allowClear={true}
                      onChange={(entityType) => {
                        self.setState({entityType:entityType},() => {
                          if (entityType >= 0) {
                            self._getSceneByType(entityType)
                          }
                        })
                      }}
                    >
                      <Option value={0}>课程</Option>
                      <Option value={1}>考试</Option>
                      <Option value={15}>报名</Option>
                      <Option value={23}>活动</Option>
                      <Option value={26}>直播</Option>
                      <Option value={38}>任务</Option>
                      <Option value={36}>班级</Option>
                    </WizSelect>
                  )}
              </WizCol>
            </WizRow>
          )
        }
      },
    },
    {
      title: '业务类型',
      name: 'bizType',
      tableItem: {},
      dict: [
        { code: 0, codeName: '课程' },
        { code: 1, codeName: '考试' },
        { code: 15, codeName: '报名' },
        { code: 23, codeName: '活动' },
        { code: 26, codeName: '直播' },
        { code: 38, codeName: '任务' },
        { code: 36, codeName: '班级' },
      ]
    },
    {
      title: '业务内容',
      name: 'bizId',
      searchItem: {
        type: 'diy',
        links: {'entityType':'业务类型'},
        diy: WizTableForm,
        selectType: 'radio',
        ...WizTableForm.Config.program(this, {}),
        changePopsFunction: (linksValues) => {
          const {entityType} = linksValues
          let config;
          if (entityType === 0) {
            config = WizTableForm.Config.program(this, {})
          } else if (entityType === 1) {
            config = WizTableForm.Config.exam(this, {})
          } else if (entityType === 15) {
            config = WizTableForm.Config.apply(this, {})
          } else if(entityType === 23) {
            config = WizTableForm.Config.activity(this, {})
          }else if(entityType === 26) {
            config = WizTableForm.Config.live(this, {})
          }else if(entityType === 38) {
            config = WizTableForm.Config.task(this, {})
          }else if(entityType === 36) {
            config = WizTableForm.Config.classInfoAll(this, {})
          }
          return config
        }
      },
    },
    {
      title: '业务内容',
      name: 'bizName',
      tableItem: {
      },
    },
    {
      title: '通知场景',
      name: 'sceneName',
      searchItem: {
        type: 'select',
        disabled: flag,
      },
      dict: sceneByTypeList
    },
    {
      title: '通知场景',
      name: 'sceneName',
      tableItem: {
      },
    },
  ]
};

const templateConfig = (e) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(e),
        searchBarProps: {
          collapse: false,
        },
        dataTableProps: {
          rowKey: "id",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['look'],
        rowOperateView: [
          {
            key: 'look',
            custom: true,
            params: { children: '查看'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/message/noticeRecord/noticeRecordDetail'
              }
            }
          }
        ],
        commonOperate: {
        }
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
};

let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
